<template>
  <el-col :span="10" class="el-col--min-25em">
    <el-popover
       ref="ref-esfis"
       placement="top-start"
       trigger="hover"
       width="240"
      :title="$t('label.help')"
      :content="select.description">
    </el-popover>

    <el-select
       v-model="select.value"
       class="w-100"
      :placeholder="placeholder"
      :disabled="disabled"
      :clearable="clearable"
      @change="update">
      <el-option
         v-for="option in options"
        :label="option.name"
        :value="option.code"
        :key="option.id">
      </el-option>
    </el-select>

    <el-button v-if="select.description" v-popover:ref-esfis>?</el-button>
  </el-col>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'evolution-settings-form-input-select',
  props: {
    id: {
      required: true,
      default: null,
    },
    code: {
      required: true,
      default: null,
    },
    options: {
      required: true,
      default: null,
    },
    description: {
      required: true,
      default: null,
    },
    input: {
      required: true,
      default: null,
    },
    value: {
      required: true,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    validation: {
      type: Object,
      required: false,
      default: null,
    },
    expressedInUnit: {
      type: String,
      required: false,
      default: null,
    },
    calculated: {
      required: false,
      default: false,
    },
  },
  data() {
    return {
      select: {
        id: null,
        code: null,
        description: null,
        value: null,
        options: null,
      },
    };
  },
    // watch: {
  //   dependsOnCustom(newValue) {
  //     if (newValue === MEASUREMENT_SETTING_TYPE_OPTIONS.CUSTOM) {
  //       this.isDisabled = false;
  //     }
  //   },
  // },
  methods: {
    update(value) {
      console.log('form-input-select update', this.select.code, this.select.id, value);
      this.$emit('set:value', {
        code: this.select.code,
        data: {
          measurement_setting_type_id: this.select.id,
          value_text: value,
        },
      });
    },
    setRule() {
      this.$emit('set:rule', {
        code: this.code,
        validation: this.validation,
        calculated: this.calculated,
      });
    },
  },
  created() {
    this.setRule();

    this.select.id = this.id;
    this.select.code = this.code;
    this.select.description = this.description;
    this.select.options = this.options;
    this.select.value = get(this.input, 'value_text') || '';
    this.update(this.select.value);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/settings/evolution-settings-form-input/cmpt-form-input-select.vue